export const SIDEBAR_ITEMS = {
  OVERVIEW: 'overview',
  ASSESSMENTS: 'assessments',
  REQUESTS: 'requests',
  THIRD_PARTIES: 'third_parties',
  FOURTH_PARTIES: 'fourth_parties',
  DISCOVERY: 'discovery',
  MONITORING: 'monitoring',
  DASHBOARDS: 'dashboards',
  SETTINGS: 'settings',
  AI_GOVERNANCE: 'ai_governance',
  OUTREACH: 'outreach',
} as const
